import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "../hooks/loyaltyFetch";
import { loyaltyApiDetail } from "./loyaltyApiMessage";

export function catalogDeletePaths(resourceType, resourceId) {
    const id = encodeURIComponent(resourceId);
    switch (resourceType) {
        case "coupon_type":
            return {
                preview: `${LOYALTY_API_BASE}/admin/coupon-types/${id}/delete-preview`,
                delete: `${LOYALTY_API_BASE}/admin/coupon-types/${id}`,
                deactivate: `${LOYALTY_API_BASE}/admin/coupon-types/${id}`,
            };
        case "reward":
            return {
                preview: `${LOYALTY_API_BASE}/rewards/${id}/delete-preview`,
                delete: `${LOYALTY_API_BASE}/rewards/${id}`,
                deactivate: `${LOYALTY_API_BASE}/rewards/${id}`,
            };
        case "product":
            return {
                preview: `${LOYALTY_API_BASE}/admin/products/${id}/delete-preview`,
                delete: `${LOYALTY_API_BASE}/admin/products/${id}`,
                deactivate: `${LOYALTY_API_BASE}/admin/products/${id}`,
            };
        default:
            return null;
    }
}

export async function fetchCatalogDeletePreview(previewUrl, brandName) {
    const res = await loyaltyFetch(previewUrl, { headers: { "X-Brand": brandName } });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(loyaltyApiDetail(data?.detail) || `Erreur HTTP ${res.status}`);
    }
    return data;
}

export function formatCatalogDeleteStats(data) {
    if (!data || typeof data !== "object") return null;
    const parts = [];
    if (Number.isFinite(data.coupons_invalidated)) parts.push(`${data.coupons_invalidated} coupon(s) invalidé(s)`);
    if (Number.isFinite(data.rewards_invalidated)) parts.push(`${data.rewards_invalidated} avantage(s) invalidé(s)`);
    if (Number.isFinite(data.products_marked_removed)) parts.push(`${data.products_marked_removed} produit(s) marqué(s) retiré(s)`);
    if (parts.length === 0) return null;
    return parts.join(" · ");
}
